/**
 * @lodex-pro/web-admin/auth/SignInPage — PLATFORM_ADMIN sign-in (Phase 25 / Task 25.1, DEC-111).
 *
 * The shared sign-in screen (web-shared SignInScreen, 2026-10-21: "All sign in screens should be
 * the same"): email + password against the platform Cognito pool, the pool's optional MFA,
 * "Forgot your password?" (the pool recovers by verified email) and the forced new password.
 *
 * On success, App re-renders through the auth + PLATFORM_ADMIN role gates — no navigation
 * needed, so onSignedIn only calls the optional test hook.
 *
 * Chrome brand: "Paelode Systems Admin" (internal admin brand, DEC-312).
 */

import { SignInScreen } from '@lodex-pro/web-shared';
import type { FC } from 'react';

export interface SignInPageProps {
  readonly onSignedIn?: () => void;
  readonly onTotpSetupRequired?: () => void;
}

export const SignInPage: FC<SignInPageProps> = ({ onSignedIn, onTotpSetupRequired }) => (
  <SignInScreen
    appName="Paelode Systems Admin"
    onSignedIn={() => {
      // App's auth gate re-renders on the Amplify Hub sign-in event; nothing to do.
      onSignedIn?.();
    }}
    onTotpSetupRequired={() => {
      if (onTotpSetupRequired !== undefined) {
        onTotpSetupRequired();
        return;
      }
      window.location.assign('/auth/totp-setup');
    }}
  />
);
